const cardTypes = [
  {value:'mainland',label:'内地身份证'}, {value:'passport',label:'护照'},
  {value:'hkid',label:'香港身份证'}, {value:'macao',label:'澳门居民身份证'},
  {value:'twid',label:'台湾身份证'}, {value:'hk_macau',label:'港澳居民来往内地通行证'},
  {value:'taiwan',label:'台湾居民来往大陆通行证'}, {value:'other',label:'其他身份证件'}
]
function documentType(value, number) {
  return value || (/^(\d{15}|\d{17}[0-9Xx])$/.test(number || '') ? 'mainland' : 'other')
}
function validDocument(value, type) {
  const number = String(value || '').trim()
  return type === 'mainland' ? /^(\d{15}|\d{17}[0-9Xx])$/.test(number) : /^[A-Za-z0-9()\-]{5,32}$/.test(number)
}
module.exports = { cardTypes, documentType, validDocument }
